export const BROADCAST_SIDE_MENU_BUTTONS = [
    { id: 'memo', name: '메모', who: '진행자·메모가 있는 방송의 시청자' },
    { id: 'liveSnapshot', name: '힛 갤러리', who: '진행자·시청자' },
    { id: 'more', name: '더보기(신고·차단)', who: '로그인한 시청자' },
    { id: 'share', name: '공유', who: '시청자(테스트 방송 제외)·테스트 방송 진행자' },
    { id: 'pip', name: 'PiP', who: 'PiP 버튼이 켜진 앱의 시청자' },
    { id: 'mute', name: '소리·마이크', who: '진행자(마이크)·시청자(소리)' },
    { id: 'switchCamera', name: '카메라 전환', who: '진행자' },
    { id: 'zoom', name: '줌', who: '진행자' },
    { id: 'inventory', name: '구매(상품 목록)', who: '진행자·시청자' },
    { id: 'createProduct', name: '등록', who: '진행자' },
];
export const BROADCAST_SIDE_MENU_BUTTON_IDS = BROADCAST_SIDE_MENU_BUTTONS.map((button) => button.id);
const GROUP = '오른쪽 버튼';
const HIDE_WARNING = {
    more: ' 시청자가 방송 화면에서 딜러를 신고·차단할 수 없게 됩니다.',
    inventory: ' 진행자 화면에서도 빠져 진행자가 이 버튼으로 판매 상품 목록을 열 수 없게 됩니다.',
    createProduct: ' 진행자가 방송 중에 상품을 등록할 수 없게 됩니다.',
};
const BUILT_IN_ORDER = BROADCAST_SIDE_MENU_BUTTONS.map((button) => button.name).join(' → ');
export const BROADCAST_SIDE_MENU_FIELDS = [
    ...BROADCAST_SIDE_MENU_BUTTONS.flatMap(({ id, name, who }, index) => [
        {
            key: `broadcast.sideMenu.${id}.order`,
            group: GROUP,
            label: `${name} 버튼 순서`,
            help: `숫자가 작을수록 위에 보입니다. 같은 숫자면 기본 순서(${BUILT_IN_ORDER})를 따릅니다. 이 버튼은 ${who}에게만 보이고, 보이지 않는 버튼은 건너뜁니다.`,
            type: 'integer',
            defaultValue: index + 1,
            min: 1,
            max: 99,
            unit: '번째',
        },
        {
            key: `broadcast.sideMenu.${id}.visible`,
            group: GROUP,
            label: `${name} 버튼 표시`,
            help: `끄면 방송 화면에서 이 버튼을 뺍니다(${who}). 켜 두어도 원래 보이지 않는 화면에는 나오지 않습니다.${HIDE_WARNING[id] ?? ''}`,
            type: 'boolean',
            defaultValue: true,
        },
    ]),
];
//# sourceMappingURL=broadcastSideMenu.js.map